<template>
  <div class="row">
    <div class="col-12 active">
      <div class="card active">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 active">
          <nav class="navbar navbar-expand-md navbar-dark bg-primary py-2 active">
            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-white"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="toggleNavbar"
            >
              <span class="mdi mdi-menu"></span>
            </button>

            <div
                class="collapse navbar-collapse justify-content-between active"
                :class="{ show: isNavbarOpen }"
                id="navbarNavAltMarkup"
            >
              <div class="navbar-nav">
                <router-link
                    v-for="route in navigationRoutes"
                    :key="route.name"
                    :to="{ name: route.name }"
                    class="nav-item nav-link"
                    :class="{ 'active': isActive(route.name) }"
                    @click="setActive(route.name)"
                >
                  {{ route.label }}
                </router-link>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolBarTargets",
  data() {
    return {
      selectedSub: null,
      isNavbarOpen: false,
      navigationRoutes: [
        { name: 'targets-SubCounty', label: 'Sub County Targets' },
        { name: 'targets-wards', label: 'Revenue Wards Targets' },
        { name: 'targets-zones', label: 'Revenue Zone Targets' },
        { name: 'targets-collectors', label: 'Revenue Collector Targets' },
        { name: 'targets-stream', label: 'Revenue Stream Targets' }
      ]
    }
  },
  mounted() {
    try {
      // Safely get from sessionStorage
      this.selectedSub = sessionStorage.getItem("selectedSub")

      // Also set based on current route if available
      if (!this.selectedSub && this.$route && this.$route.name) {
        this.selectedSub = this.$route.name
        this.updateSessionStorage(this.$route.name)
      }
    } catch (error) {
      console.error('Error in ToolBarTargets mounted hook:', error)
    }
  },
  methods: {
    goTo(route) {
      try {
        if (this.$router) {
          this.$router.push({ name: route })
          this.setActive(route)
        }
      } catch (error) {
        console.error('Navigation error:', error)
      }
    },
    setActive(route) {
      this.selectedSub = route
      this.updateSessionStorage(route)
      // Close navbar on mobile after selection
      this.isNavbarOpen = false
    },
    updateSessionStorage(value) {
      try {
        if (value) {
          sessionStorage.setItem("selectedSub", value)
        }
      } catch (error) {
        console.warn('Could not update sessionStorage:', error)
      }
    },
    isActive(route) {
      // Check both the stored selection and current route
      return this.selectedSub === route || (this.$route && this.$route.name === route)
    },
    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen
    },
    // Check if route exists in router
    routeExists(routeName) {
      if (!this.$router) return false

      const routes = this.$router.options.routes || []
      return routes.some(route => route.name === routeName)
    }
  },
  watch: {
    // Update selectedSub when route changes
    '$route.name': {
      handler(newRouteName) {
        if (newRouteName) {
          this.selectedSub = newRouteName
          this.updateSessionStorage(newRouteName)
        }
      },
      immediate: false
    }
  },
  beforeMount() {
    // Validate that all routes exist
    if (this.$router) {
      this.navigationRoutes = this.navigationRoutes.filter(route => {
        const exists = this.routeExists(route.name)
        if (!exists) {
          console.warn(`Route ${route.name} does not exist in router configuration`)
        }
        return exists
      })
    }
  }
}
</script>

<style scoped>
/* Custom styles for the navigation */
.navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.8) !important;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  border-radius: 4px;
  margin: 0 2px;
  text-decoration: none;
}

.navbar-nav .nav-link:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-nav .nav-link.active {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 500;
}

.navbar-toggler {
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.navbar-toggler:focus {
  box-shadow: none;
  outline: none;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .navbar-nav {
    margin-top: 1rem;
    width: 100%;
  }

  .navbar-nav .nav-link {
    margin: 2px 0;
    display: block;
    width: 100%;
  }
}

/* Ensure proper text color in dark theme */
.bg-primary .navbar-toggler {
  color: white;
}

.mini-nav {
  border-radius: 0.25rem;
}

/* Fix for Bootstrap collapse animation */
.navbar-collapse {
  transition: height 0.3s ease;
}

.navbar-collapse.show {
  display: block !important;
}
</style>